"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UIPage = require("./../UIPage.js"),
    regionalLayout = require("./../../layouts/RegionalLayout"),
    template = require("./PropertyOnDemand.html"),
    api = require("./../../../network/api.js"),
    loader = require("./../../components/Loading/loading.js"),
    Notify = require("./../../components/Notification/notifications.js"),
    $ = "undefined" != typeof window ? window.jQuery : "undefined" != typeof global ? global.jQuery : null,
    ondemandreports = require("../../components/Reports/Reports.js"),
    session = require("./../../../session");
var PropertyOnDemand = function (_UIPage) {
  _inherits(PropertyOnDemand, _UIPage);

  function PropertyOnDemand() {
    _classCallCheck(this, PropertyOnDemand);

    return _possibleConstructorReturn(this, (PropertyOnDemand.__proto__ || Object.getPrototypeOf(PropertyOnDemand)).call(this, template, { title: "Property On Demand" }));
  }

  _createClass(PropertyOnDemand, [{
    key: "onComponentReadyAsync",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var e;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                document.querySelector("omnibar-shell").pageId = "propertyondemand";
                document.querySelector("omnibar-page-header").pageTitle = "On Demand Reports";
                window.Omnibar.GetPropertyLevelHelpLink(window.location);

                if (!(void 0 != this.data.src)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return new ondemandreports(1e3, session.activePropertyId, this.data.src, this.data.bookId, this.data.type);

              case 6:
                _context.t0 = _context.sent;
                _context.next = 12;
                break;

              case 9:
                _context.next = 11;
                return new ondemandreports(1e3, session.activePropertyId, "sp");

              case 11:
                _context.t0 = _context.sent;

              case 12:
                _context.t1 = $("#pnlPropertyReportSelector");

                (e = _context.t0).attach(_context.t1);

                e.renderAsync();

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onComponentReadyAsync() {
        return _ref.apply(this, arguments);
      }

      return onComponentReadyAsync;
    }()
  }]);

  return PropertyOnDemand;
}(UIPage);

module.exports = PropertyOnDemand;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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